// extracted by mini-css-extract-plugin
export default {"genericCard":"Rp-z","inline":"Sp-z","mastercard":"Tp-z","discover":"Up-z","visa":"Vp-z","amex":"Wp-z","active":"Xp-z"};